import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import ZoneForm from './form';
import './editZones.scss';

class EditZone extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(formValues) {
    const {code, goBack} = this.props;

    if (code) {
      await this.props.editZone(code, formValues);
    } else {
      await this.props.addZone(formValues);
    }
    goBack();
  }

  render() {
    const {code, goBack, push} = this.props;

    return (
      <ZoneForm
        goBack={goBack}
        push={push}
        code={code}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
  };
};

const {
  addZone,
  editZone,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  addZone,
  editZone,
})(EditZone));
